import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BarChart3 } from "lucide-react";

const fmt = (v, format) => {
  if (v == null) return "-";
  if (format === "inr") {
    const abs = Math.abs(v);
    if (abs >= 1_00_00_000) return `INR ${(v / 1_00_00_000).toFixed(1)} Cr`;
    if (abs >= 1_00_000) return `INR ${(v / 1_00_000).toFixed(1)} L`;
    return `INR ${v.toLocaleString("en-IN")}`;
  }
  if (format === "pct") return `${v}%`;
  if (format === "ratio") return `${v}x`;
  if (format === "days") return `${v} days`;
  if (format === "count") return v.toLocaleString();
  return v;
};

const EfficiencyMetrics = ({ efficiency }) => {
  if (!efficiency || efficiency.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="efficiency-metrics">
      {efficiency.map((group) => (
        <Card key={group.name} className="card-industrial">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm flex items-center gap-2">
              <BarChart3 className="w-4 h-4 text-primary" />
              {group.name}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="divide-y">
              {group.metrics.map((m, i) => (
                <div key={i} className="flex items-center justify-between px-4 py-2.5">
                  <span className="text-xs text-muted-foreground">{m.label}</span>
                  <span className="text-sm font-medium">{fmt(m.value, m.format)}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default EfficiencyMetrics;
